export const LEGAL_SOCIAL_LOGIN: string = `

### <!--= ++sectionIndex -->. Social Login
<!-- subSectionIndex = 0; -->

On our website, we offer you the possibility to register and log in using one of your existing social media accounts. If you choose to do so, please be aware that you'll be sharing certain profile elements with us. This might include your name, email address, and possibly your profile picture, depending on the platform. This information is collected by the social media provider and transmitted to us in accordance with its privacy policy.

Please note that when using these social login services, you are not only subject to our Privacy Policy but also the privacy policies of the respective providers.

<!-- if (addons.socialLogin.facebook) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Facebook

We have incorporated the Facebook Login service to allow you to connect your Facebook profile to our service. If you decide to use this, we will receive your publicly available profile information from Facebook.

The data controller for Facebook Login is Facebook Ireland Ltd., 4 GrandCanal Square, Grand Canal Harbour, Dublin 2, Ireland.

If you decide to use Facebook Login, your data may be transferred to the USA. The data transfer to the USA is based on the standard contractual clauses of the EU Commission.

For more details, please refer to: [Facebook’s Privacy Policy](https://www.facebook.com/about/privacy/)
<!-- } -->

<!-- if (addons.socialLogin.apple) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Apple

We use Apple Login as one of our signup/login options. If you choose to use this, Apple shares with us your name and email address to enable us to create and support your account. The data processing is based on your consent according to Article 6(1)(a) GDPR / DSGVO.

The provider is Apple Inc, One Apple Park Way, Cupertino, CA 95014, USA

Apple's privacy policy can be viewed here: [Apply Privacy Policy](https://www.apple.com/legal/privacy/)
<!-- } -->

<!-- if (addons.socialLogin.google) { -->
#### <!--= sectionIndex -->.<!--= ++subSectionIndex -->. Google

We use Google Login on our website, a service from Google LLC, 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA

Google Login allows you to sign in to our website with your Google Account credentials. If you use this option, we will receive your email address, name, and profile picture from your Google profile.

Data transfer to the USA is based on the standard contractual clauses of the EU Commission.

For more information about Google's data privacy, visit [Google's Privacy Policy](https://policies.google.com/privacy)
<!-- } -->
`;
